import React, { useState } from "react";
import $ from "jquery";

import importAll from "../components/chat-component/images";
import LabelView from "../components/chat-component/labels/LabelView";
import { useDispatch, useSelector } from "react-redux";
import {
  getParticularConversation,
  resetConversation,
} from "../features/chatbot/getParticularConversationSlice";
import { clearAllConversations } from "../features/chatbot/clearAllConversationsSlice";
import { updateConversation } from "../features/chatbot/updateConversationSlice";
import { OK } from "../constants/statusCode";
import {
  getConversations,
  resetConversationList,
} from "../features/chatbot/getConversationsSlice";
import { clearParticularConversation } from "../features/chatbot/clearParticularConversationSlice";
import logoutImg from "../assets/images/logout.svg";
import { logoutData } from "../features/auth/logout/logoutSlice";
import { clearSession } from "../utils/localSession";
import { useContext } from "react";
import { SocketContext } from "../socket/socket";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "../common/modal/ConfirmationModal";
import { cancelSendQuestionData } from "../services/chatbot/api";
const images = importAll(
  require.context("../assets/images/", false, /\.(png|jpe?g|svg|GIF|webp)$/)
);

const handleSidebarToggle = () => {
  $(".main-wrapper").toggleClass("chat-collapsed");
};

const handleDocumentSidebarToggle = () => {
  $(".collpased-lang").slideToggle(200);
};

export default function LeftSidebar({
  siteData,
  selectedDocument,
  setSelectedDocument,
  contentFromSearch,
  setContentFromSearch,
  selectedConversation,
  setSelectedConversation,
  projectSlug,
  setLoadingPromptData,
  setSelectedConversationName,
  payloadData,
  setSelectedOptions,
  setSelectedLabelOptions,
  setFilterOption,
  filterOptions,
  selectedFilter,
  setSelectedFilter,
  setOldConversationInitialMessage,
}) {
  const [editOpen, setEditOpen] = useState(false);

  const [deleteClick, setDeleteClick] = useState(false);

  const [conversationName, setConversationName] = useState("");

  const [currentModal, setCurrentModal] = useState("");

  const [clearConversationFlag, setClearConversationFlag] = useState(false);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { conversationList } = useSelector(
    (state) => state.getConversationsData
  );

  const labelData = {
    labels: [
      {
        id: 11,
        uuid: "da61f39b-df01-4b60-939b-a1f09f8965d1",
        label_id: null,
        name: "Label1",
        color_hex: "b99aff",
        SubLabel: [
          {
            id: 12,
            uuid: "15f4ae0f-e3f6-4b1b-b0eb-cd7342295424",
            label_id: 11,
            name: "Label1.1",
            color_hex: "e7e7e7",
            SubLabel: [],
          },
        ],
        Project: {
          uuid: "5e33eee9-fde2-4f0a-b69d-3b2ac5915f9c",
          name: "First-Project1",
        },
      },
    ],
  };

  const conversations = [
    {
      id: 1,
      value: "How InvoiceOwl help me",
    },
    {
      id: 2,
      value: "Why InvoiceOwl help me",
    },
    {
      id: 3,
      value: "What InvoiceOwl help me",
    },
    {
      id: 4,
      value: "Who is InvoiceOwl",
    },
  ];

  const selectParticularConversation = (_uuid) => {
    if (_uuid !== selectedConversation) {
      setEditOpen(false);
      setSelectedConversation(_uuid);
      deleteClick && selectedConversation !== _uuid && setDeleteClick(false);
      cancelSendQuestionData();
      dispatch(getParticularConversation(_uuid));
    }
  };

  const clearConversationsData = async () => {
    if (conversationList.length > 0) {
      cancelSendQuestionData();
      const { payload } = await dispatch(clearAllConversations(projectSlug));
      if (payload.status === OK) {
        dispatch(getConversations(projectSlug));
        setLoadingPromptData("");
        setSelectedConversation("");
        setClearConversationFlag(false);
        toggleModal();
      }
    }
  };

  const saveEditedConversationName = async (uuid) => {
    const { payload } = await dispatch(
      updateConversation({
        filter: payloadData?.filter,
        name: conversationName,
        conversationId: uuid,
      })
    );
    setSelectedConversationName(conversationName);
    if (payload.status === OK) {
      dispatch(getConversations(projectSlug));
    }
    setEditOpen(false);
  };

  const deleteParticularConversation = async (_conversationId) => {
    cancelSendQuestionData();
    const { payload } = await dispatch(
      clearParticularConversation(_conversationId)
    );
    if (payload.status === OK) {
      dispatch(resetConversation());
      dispatch(getConversations(projectSlug));
      setSelectedConversation("");
      setSelectedOptions([]);
      setSelectedLabelOptions([]);
      setSelectedConversationName("");
      setConversationName("");
      setFilterOption(filterOptions);
      setSelectedFilter([]);
      setLoadingPromptData("");
    }
    setDeleteClick(false);
  };

  const socketContext = useContext(SocketContext);

  const toggleModal = () => {
    setCurrentModal("");
  };

  const handleLogout = async () => {
    const { payload } = await dispatch(logoutData());
    if (payload.status === OK) {
      clearSession();
      navigate("/login");
    }
    socketContext.socket.disconnect("disconnect", () => {});
  };

  return (
    <div className="leftlang-box sidebar-overflow">
      <button
        type="button"
        className="slide-arrow btn"
        onClick={() => handleSidebarToggle()}
      >
        {" "}
        <img src={images["chat-slide-arrow.svg"]} alt="" />
      </button>
      <div className="mobile-block chat-only-forscroll chat-list-new">
        {/* <div
          className="lang-heading active"
          onClick={() => handleDocumentSidebarToggle()}
        >
          <img src={images["fileicn.svg"]} alt="" className="file-icn" />
          <p>Documents</p>
          <img
            src={images["select-arrow.svg"]}
            alt=""
            className="file-edit-icn"
          />
        </div> */}
        <button
          type="button"
          className="btn newchat-btn w-100 d-flex justify-content-between"
          onClick={async () => {
            cancelSendQuestionData();
            await dispatch(resetConversation());
            setSelectedConversation("");
            setSelectedOptions([]);
            setSelectedLabelOptions([]);
            setSelectedConversationName("");
            setFilterOption(filterOptions);
            setSelectedFilter([]);
            setOldConversationInitialMessage("Hi! What can I help you with?");
            setClearConversationFlag(false);
            setLoadingPromptData("");
          }}
        >
          <span>New Chat</span>
          <img src={images["plus-btn-lg.svg"]} alt="" />
        </button>
        <ul className="chat-label-list">
          {conversationList &&
            conversationList.length > 0 &&
            conversationList.map((_data, _idx) => (
              <li
                className={`chat-label ${
                  selectedConversation === _data.uuid ? "active" : ""
                }`}
                key={_idx}
                onClick={async () => {
                  if (_data.uuid !== selectedConversation) {
                    await dispatch(resetConversation());
                  }
                  setClearConversationFlag(false);
                  setSelectedOptions([]);
                  setSelectedLabelOptions([]);
                  setFilterOption(filterOptions);
                  setSelectedConversationName(_data.name);
                  setConversationName(_data.name);
                  selectParticularConversation(_data.uuid);
                  setOldConversationInitialMessage(_data.initial_message);
                }}
              >
                <div
                  className={`chat-label-btn btn ${
                    selectedConversation === _data.uuid ? "disabled-p" : ""
                  }`}
                >
                  {!deleteClick || selectedConversation !== _data.uuid ? (
                    <img
                      src={images["icn_chat.svg"]}
                      alt=""
                      className="chat-label-img"
                    />
                  ) : (
                    selectedConversation === _data.uuid && (
                      <img
                        src={images["trash-chat.svg"]}
                        alt=""
                        className="chat-label-img"
                      />
                    )
                  )}
                  {editOpen && selectedConversation === _data.uuid ? (
                    <input
                      type="text"
                      className="form-control"
                      defaultValue={_data.name}
                      onChange={(e) => setConversationName(e.target.value)}
                      // onBlur={() => setEditOpen(false)}
                      autoFocus
                    />
                  ) : (
                    <span className="chat-label">
                      {deleteClick &&
                        selectedConversation === _data.uuid &&
                        "Delete "}{" "}
                      {_data.name.replaceAll("<br/>", " ")}
                    </span>
                  )}
                </div>
                {selectedConversation === _data.uuid && (
                  <>
                    {!editOpen && !deleteClick ? (
                      <div className="chat-action">
                        <button
                          type="button"
                          className="chat-act-btn btn"
                          onClick={() => setEditOpen(true)}
                        >
                          <img src={images["icn_edit.svg"]} alt="" />
                        </button>
                        <button
                          type="button"
                          className="chat-act-btn btn"
                          onClick={() => {
                            setDeleteClick(true);
                          }}
                        >
                          <img src={images["icn_delete.svg"]} alt="" />
                        </button>
                      </div>
                    ) : (
                      <>
                        <div className="chat-action edit-lable-btns">
                          <button
                            type="button"
                            className="chat-act-btn btn"
                            onClick={() => {
                              editOpen
                                ? saveEditedConversationName(_data.uuid)
                                : deleteParticularConversation(_data.uuid);
                            }}
                          >
                            <img src={images["writei_icn.svg"]} alt="" />
                          </button>
                          <button
                            type="button"
                            className="chat-act-btn btn"
                            onClick={() => {
                              setEditOpen(false);
                              setDeleteClick(false);
                            }}
                          >
                            <img src={images["cross_icn.svg"]} alt="" />
                          </button>
                        </div>
                      </>
                    )}
                  </>
                )}
              </li>
            ))}

          {/* <li
            className="chat-label 
          "
          >
            <div className="chat-label-btn btn">
              <img
                src={images["icn_chat.svg"]}
                alt=""
                className="chat-label-img"
              />

              <div className="chat-action edit-lable-btns">
                <button type="button" className="chat-act-btn btn">
                  <img src={images["writei_icn.svg"]} alt="" />
                </button>
                <button type="button" className="chat-act-btn btn">
                  <img src={images["cross_icn.svg"]} alt="" />
                </button>
              </div>
            </div>
          </li>
          <li className="chat-label ">
            <div className="chat-label-btn btn">
              <img
                src={images["icn_chat.svg"]}
                alt=""
                className="chat-label-img"
              />{" "}
              <span className="chat-label">Invoicing for Event Invitation</span>
            </div>
          </li> */}
        </ul>
        <div className="clear-conv-btn ">
          {conversationList.length > 0 && (
            <div
              className="bottom-btn btn w-100 text-start"
              onClick={() => setCurrentModal("confirmDelete")}
            >
              <>
                <span className="bottom-btn-icon">
                  <img
                    src={images["trash-chat.svg"]}
                    alt=""
                    className="chat-label-img me-0"
                  />{" "}
                </span>
                <span className="chat-label">Clear Conversations</span>
              </>
              {/*    {!clearConversationFlag ? (
              ) : (
                <>
                  <span className="bottom-btn-icon">
                    <img
                      src={images["writei_icn.svg"]}
                      alt=""
                      className="chat-label-img me-0"
                      width="12px"
                    />{" "}
                  </span>
                  <span className="chat-label">
                    Confirm clear conversations
                  </span>
                </>
              )} */}
            </div>
          )}
          <div
            className="bottom-btn btn w-100 text-start"
            onClick={() => handleLogout()}
          >
            <span className="bottom-btn-icon">
              <img
                src={logoutImg}
                alt="logout"
                className="chat-label-img me-0"
              />{" "}
            </span>
            <span className="chat-label">Logout</span>
          </div>
        </div>

        {/* <div className="lang-list-label">
          <div className="list-label-title">Labels</div>
          <ul className="emply-list-ul chat-list-left">
            <li>
              <LabelView
                contentFromSearch={contentFromSearch}
                setContentFromSearch={setContentFromSearch}
                // labelsData={siteData?.labels}
                labelsData={labelData?.labels}
                selectedDocument={selectedDocument}
                setSelectedDocument={setSelectedDocument}
              />
            </li>
          </ul>
        </div> */}
      </div>
      {currentModal === "confirmDelete" && (
        <ConfirmationModal
          title={"Clear All Conversations "}
          isOpen={currentModal === "confirmDelete"}
          toggle={toggleModal}
          onConfirm={clearConversationsData}
          message="Are you sure you want clear All Conversations?"
        />
      )}
    </div>
  );
}
